import mongoose from "mongoose";

import { ILeaveRequest } from "../models/leave-request";

export function formatLeaveRequestDocument(
  leaveRequest: ILeaveRequest,
): Record<string, unknown> {
  const lrDoc = leaveRequest as ILeaveRequest & {
    student?: {
      id?: string;
      _id?: mongoose.Types.ObjectId;
      fullName?: string;
      studentId?: string;
      profilePicture?: unknown;
    };
    approvedBy?: {
      id?: string;
      _id?: mongoose.Types.ObjectId;
      fullName?: string;
      email?: string;
    };
    rejectedBy?: {
      id?: string;
      _id?: mongoose.Types.ObjectId;
      fullName?: string;
      email?: string;
    };
    appealReviewedBy?: {
      id?: string;
      _id?: mongoose.Types.ObjectId;
      fullName?: string;
      email?: string;
    };
    durationDays?: number;
  };

  const student = lrDoc.student;
  const appeal = lrDoc.appeal;

  return {
    id: leaveRequest.id,
    studentId: leaveRequest.studentId?.toString(),
    classId: leaveRequest.classId?.toString() ?? null,
    className: leaveRequest.className ?? null,
    leaveType: leaveRequest.leaveType,
    date:
      leaveRequest.startDate &&
      leaveRequest.endDate &&
      leaveRequest.startDate.toISOString().slice(0, 10) ===
        leaveRequest.endDate.toISOString().slice(0, 10)
        ? leaveRequest.startDate.toISOString().slice(0, 10)
        : null,
    startDate: leaveRequest.startDate,
    endDate: leaveRequest.endDate,
    reason: leaveRequest.reason,
    status: leaveRequest.status,
    durationDays: lrDoc.durationDays,
    student: student
      ? {
          id: student.id || student._id?.toString(),
          fullName: student.fullName,
          studentId: student.studentId,
          profilePicture: student.profilePicture,
        }
      : null,
    approvedBy: lrDoc.approvedBy
      ? {
          id: lrDoc.approvedBy.id || lrDoc.approvedBy._id?.toString(),
          fullName: lrDoc.approvedBy.fullName,
          email: lrDoc.approvedBy.email,
          role: leaveRequest.approvedByRole ?? null,
        }
      : null,
    approvedAt: leaveRequest.approvedAt,
    rejectedBy: lrDoc.rejectedBy
      ? {
          id: lrDoc.rejectedBy.id || lrDoc.rejectedBy._id?.toString(),
          fullName: lrDoc.rejectedBy.fullName,
          email: lrDoc.rejectedBy.email,
          role: leaveRequest.rejectedByRole ?? null,
        }
      : null,
    rejectedAt: leaveRequest.rejectedAt,
    rejectionReason: leaveRequest.rejectionReason,
    documents: leaveRequest.documents,
    appeal: appeal
      ? {
          reason: appeal.reason,
          documents: appeal.documents,
          submittedAt: appeal.submittedAt,
          reviewedBy: lrDoc.appealReviewedBy
            ? {
                id:
                  lrDoc.appealReviewedBy.id ||
                  lrDoc.appealReviewedBy._id?.toString(),
                fullName: lrDoc.appealReviewedBy.fullName,
                role: appeal.reviewedByRole,
              }
            : null,
          reviewedAt: appeal.reviewedAt,
          reviewNotes: appeal.reviewNotes,
          status: appeal.status,
        }
      : null,
    createdAt: leaveRequest.createdAt,
    updatedAt: leaveRequest.updatedAt,
  };
}
